import { http } from './http'

export function getTags () {
  return http.get('/api/tags')
}

export function getKitchenTags () {
  return http.get('/api/kitchen/tags')
}

export function createKitchenTag (payload) {
  return http.post('/api/kitchen/tags', payload)
}

export function updateKitchenTag (id, payload) {
  return http.put(`/api/kitchen/tags/${id}`, payload)
}

export function setKitchenTagActive (id, active) {
  return http.put(`/api/kitchen/tags/${id}/active`, { active })
}
